<ndt-user-register [filters]="filters" [showCreate]="true" [showAllUsersControl]="false"></ndt-user-register>
